import { render } from "./Inputsize.vue?vue&type=template&id=1827de82"
import script from "./Inputsize.vue?vue&type=script&lang=js"
export * from "./Inputsize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__